var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"95%","margin-top":"3.5rem"},attrs:{"id":"echart-media"}})
}
var staticRenderFns = []

export { render, staticRenderFns }